import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Input,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { createNewAssistant } from "../utility/createNewAssistant";
import { useAuth } from "../../context/AuthContext";

interface CreateNewBotDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  setReload: (reload: boolean) => void;
}

export const CreateNewBotDialog: React.FC<CreateNewBotDialogProps> = ({
  isOpen,
  setIsOpen,
  setReload,
}) => {
  const { idToken, refreshAuthSession } = useAuth();
  const [botName, setBotName] = useState<string>("");
  const [systemPrompt, setSystemPrompt] = useState<string>("");

  const handleCreate = () => {
    if (!idToken) return;

    if (botName.trim() && systemPrompt.trim()) {
      createNewAssistant(idToken, {
        assistant_name: botName,
        assistant_instructions: systemPrompt,
      }).then(() => {
        setReload(true);
      });

      setBotName("");
      setSystemPrompt("");
      setIsOpen(false);
    }
  };

  const handleCancel = () => {
    // フォームをリセット
    setBotName("");
    setSystemPrompt("");
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} maxWidth="md" fullWidth>
      <DialogTitle>BOTの作成</DialogTitle>
      <DialogContent>
        <Typography variant="h6" sx={{ mb: 1, mt: 2 }}>
          BOTの名前
        </Typography>
        <TextField
          fullWidth
          placeholder="チャットボットの名前を入力してください"
          value={botName}
          onChange={(e) => setBotName(e.target.value)}
          sx={{ mb: 3 }}
        />

        <Typography variant="h6" sx={{ mb: 1 }}>
          システムプロンプト
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={8}
          placeholder="チャットボットの動作を定義するシステムプロンプトを入力してください"
          value={systemPrompt}
          onChange={(e) => setSystemPrompt(e.target.value)}
          sx={{ mb: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>キャンセル</Button>
        <Button
          onClick={handleCreate}
          variant="contained"
          disabled={!botName.trim() || !systemPrompt.trim()}
        >
          作成
        </Button>
      </DialogActions>
    </Dialog>
  );
};
